import { type MaybeRef, unref } from 'vue'

/**
 * El id del usuario que toca cargar, como número.
 *
 * Vive en su propio archivo, sin una sola dependencia de la app, por dos razones: para
 * poder fijarlo en una prueba sin levantar el navegador, y porque aquí hubo un bug que
 * costó encontrar.
 *
 * La llave de caché de vue-query se armaba con `Number(userId)` sobre un REF, y `Number()`
 * de un ref no da el número — da `NaN`. O sea que TODOS los usuarios compartían la misma
 * entrada de caché, `['user', contexto, NaN]`, y al abrir la edición de uno aparecían los
 * datos del que se había visto antes: el encabezado decía «Aldo Viajero» mientras el
 * formulario traía a Agustín.
 *
 * El orden es el de siempre: lo que pase quien llama, luego los params, y al final la
 * ruta. Vue Router entrega un parámetro repetido como arreglo, así que se toma el primero
 * en vez de dejar que `Number(['26879'])` decida.
 */
export const resolveUserId = (
	explicitId?: string | number,
	paramsId?: MaybeRef<string | number | undefined>,
	routeId?: string | string[]
): number => {
	const fromRoute = Array.isArray(routeId) ? routeId[0] : routeId

	return Number(explicitId || unref(paramsId) || fromRoute || 0)
}
